import { InjectionToken, makeStateKey } from '@angular/core'
import { Database } from 'src/server/database/Database'
import { Request, Response } from 'express'

export interface NodeEnv extends NodeJS.ProcessEnv {
  REDIRECTOR_MYSQL_HOST: string
  REDIRECTOR_MYSQL_USER: string
  REDIRECTOR_MYSQL_PASS: string
  REDIRECTOR_MYSQL_DB: string
  REDIRECTOR_MYSQL_PORT?: string
}

export const ED_INJECT_EXPRESS_REQUEST = new InjectionToken<Request>('ed_inject_express_request')
export const ED_INJECT_EXPRESS_RESPONSE = new InjectionToken<Response>('ed_inject_express_response')
export const ED_INJECT_DATABASE = new InjectionToken<Database>('ed_inject_database')
export const ED_INJECT_APP_BASE_HREF = new InjectionToken<Database>('ED_INJECT_APP_BASE_HREF')
export const ED_INJECT_HOST = new InjectionToken<string>('ed_inject_host')
export const ED_INJECT_DOMAIN = new InjectionToken<string>('ed_inject_domain')
export const ED_INJECT_LOCALE_ID = new InjectionToken<string>('ed_inject_locale_id')

export const ED_STORE_LOCALE_ID = makeStateKey<string>('ed_store_locale_id')
export const ED_STORE_APP_BASE_HREF = makeStateKey<string>('ed_inject_app_base_href')
export const ED_STORE_HOST = makeStateKey<string>('ed_store_host')
export const ED_STORE_DOMAIN = makeStateKey<string>('ed_store_domain')

export const PageLocales = [
  { key: 'de' },
  { key: 'en' },
  { key: 'zh' },
  { key: 'es' },
  { key: 'fr' },
]

export enum CookieKey {
  I18nSelection = 'i18n_selection',
}
